import React, {useContext, useEffect, useState} from 'react';
import {Button, Upload, UploadFile} from "antd";
import {UploadOutlined} from "@ant-design/icons";
import {ProductAttributeType} from "../../tabs/ProductAttributes";
import {CatalogContext} from "../../../../../providers/CatalogProvider";

type ProductAttributeImageItemProps = {
    attr: ProductAttributeType
}

const ProductAttributeImageItem = ({attr}: ProductAttributeImageItemProps) => {
    const {attributes, setAttributes} = useContext(CatalogContext)

    const [pictureList, setPictureList] = useState<UploadFile[]>([])

    const handleChangeImageUrl: HandleChangeAttributeImageUrl = (value, name) => {
        setAttributes(attributes.map(item => ({
            ...item,
            value: item.id === attr.id ? value : item.value,
            imageName: item.id === attr.id ? name.replace(/\.[^/.]+$/, '') : item.imageName,
            status: item.id === attr.id ? 'changed' : item.status,
        })))
    }

    const handleSetPictureList = () => {
        if (attr.imageName && attr.value) {
            const newPic = {
                uid: attr.id.toString(),
                name: attr.imageName as string,
                thumbUrl: attr.value as string,
            }

            setPictureList([newPic])
        }
    }

    useEffect(() => {
        handleSetPictureList()
    }, []);

    return (
        <Upload
            onPreview={() => {}}
            beforeUpload={(file) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)

                reader.onload = () => {
                    handleChangeImageUrl(reader.result as string, file.name)
                    handleSetPictureList()
                }

                return false
            }}
            fileList={pictureList.length !== 0 ? pictureList : undefined}
            showUploadList={{showRemoveIcon: false}}
            accept=".png,.svg,.jpeg,.webp"
            listType="picture"
            maxCount={1}
        >
            <Button style={{width: "100%"}} icon={<UploadOutlined/>}>Select Image</Button>
        </Upload>
    );
};

export default ProductAttributeImageItem;

type HandleChangeAttributeImageUrl = (value: string, name: string) => void
